module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4hOQB"))).then(() => module.bundle.root('1iHdE'));